import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "protocol_div"
};
var _hoisted_2 = ["innerHTML"];

var _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin-top": "0.8rem"
  }
}, [/*#__PURE__*/_createElementVNode("h3", null, "关于客户个人信息收集、使用及保护的公告"), /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("p", null, "尊敬的客户："), /*#__PURE__*/_createElementVNode("p", null, "您好！"), /*#__PURE__*/_createElementVNode("p", null, "根据《中华人民共和国个人信息保护法》、《中华人民共和国数据安全法》、《中华人民共和国网络安全法》、《全国人民代表大会常务委员会关于加强网络信息保护的决定》、《电信和互联网用户个人信息保护规定》（工业和信息化部令第24号）和《电话用户真实身份信息登记规定》（工业和信息化部令第25号）等国家法律法规的要求，客户在移动公司各类营业网点（含自有营业厅、手机营业厅、网上营业厅、授权合作代理店等）办理移动电话卡（含无线上网卡）、固定电话、家庭宽带入网、过户以及需要出示客户证件的有关业务时，客户应配合出示有效身份证件原件并进行查验、登记。登记信息包括姓名、证件类型、证件号码等。同时，为更好地提供服务，可能需要客户提供如联系人、联系电话、通信地址、电子邮箱等信息。您在使用套餐类业务办理、通用流量包类业务办理、定向流量包类业务办理、权益+流量包办理、语音短信这类业务办理服务时，我们可能需要收集和使用您的手机号码、短信验证码，确保成功为您办理业务。"), /*#__PURE__*/_createElementVNode("p", null, "上述数据会提供给我们的合作运营商中国移动，用于为您办理业务。在接受和使用中国移动通信有限公司销售分公司的服务和产品前，您应了解中国移动通信有限公司销售分公司的《隐私和信息保护政策》（完整政策可查看网页https://dev.coc.10086.cn/coc/web2/Agreement/），同意本文件即视为您已了解并同意中国移动通信有限公司销售分公司的隐私和信息保护政策。"), /*#__PURE__*/_createElementVNode("p", null, "客户本人持有效身份证件可通过自有营业厅查询和/或更正本人信息，或登录手机营业厅查询本人信息。如客户拒绝依法提供个人有效证件及真实信息，中国移动有权不提供服务或终止服务。"), /*#__PURE__*/_createElementVNode("p", null, "为向客户提供优质、个性化的服务，我公司将遵循合法、正当、必要的原则，按照法律法规规定和/或协议约定使用留存客户个人信息，并妥善保管，严格保密，依法保护客户个人信息，非因下列事由，不对外提供客户个人信息："), /*#__PURE__*/_createElementVNode("p", null, "1）事先获得客户的明确授权；"), /*#__PURE__*/_createElementVNode("p", null, "2）根据有关的法律法规要求；"), /*#__PURE__*/_createElementVNode("p", null, "3）按照相关司法机关和/或政府主管部门的要求；"), /*#__PURE__*/_createElementVNode("p", null, "4）为维护社会公众的利益所必需且适当；"), /*#__PURE__*/_createElementVNode("p", null, "5）为维护我公司或客户的合法权益所必需且适当；"), /*#__PURE__*/_createElementVNode("p", null, "6）为确保您能成功办理中国移动独立或与我们合作的运营活动，我们会将您提交的信息提供给中国移动。"), /*#__PURE__*/_createElementVNode("p", {
  style: {
    "text-align": "right"
  }
}, "杭州我爱号码网电子商务有限公司")])], -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_popup = _resolveComponent("van-popup");

  return _openBlock(), _createBlock(_component_van_popup, {
    show: $options.showMobile,
    "onUpdate:show": _cache[1] || (_cache[1] = function ($event) {
      return $options.showMobile = $event;
    }),
    closeable: true,
    round: "",
    style: _normalizeStyle({
      padding: '0.35rem',
      height: '80%'
    })
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
        innerHTML: $props.protocolContent
      }, null, 8, _hoisted_2), _hoisted_3, _createElementVNode("footer", {
        class: "ikown",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return $options.showMobile = false;
        })
      }, "我已知晓")])];
    }),
    _: 1
  }, 8, ["show", "style"]);
}